enum RouteKey {
  BaseRoute = 'BaseRoute',
  Playground = 'Playground',
  __DEPRECATED__Login = '__DEPRECATED__Login',
  Login = 'Login',
  Logout = 'Logout',
  UpdatePassword = 'UpdatePassword',
  ForgotPassword = 'ForgotPassword',
  ChangePassword = 'ChangePassword',
  SSORedirect = 'SSORedirect',
  ContactUs = 'ContactUs',
  Campaigns = 'Campaigns',
  Notifications = 'Notifications',
  NotificationsDefinitions = 'NotificationsDefinitions',
  Advertisers = 'Advertisers',
  Billing = 'Billing',
  Usage = 'Usage',
  AccountSettings = 'AccountSettings',
  Dashboard = 'Dashboard',
  DashboardInfo = 'DashboardInfo',
  Metrics = 'Metrics',
  AudienceInsights = 'AudienceInsights',
  Reports = 'Reports',
  OutputDataFeeds = 'OutputDataFeeds',
  CampaignBrief = 'CampaignBrief',
  CampaignBriefPreview = 'CampaignBriefPreview',
  AccountIntegrations = 'AccountIntegrations',
  UserRules = 'UserRules',
  AccountPermissions = 'AccountPermissions',
  UserPermissions = 'UserPermissions',
  AllUsers = 'AllUsers',
  LinkedAgencies = 'LinkedAgencies',
  AuditTrail = 'AuditTrail',
  UsageLimits = 'UsageLimits',
  DataSources = 'DataSources',
  RepositoryTargets = 'RepositoryTargets',
  AccountDspEditor = 'AccountDspEditor',
  DspLibrary = 'DspLibrary',
  DoohScreens = 'DoohScreens',
  ExternalAuthIntegration = 'ExternalAuthIntegration',
  AccountsManagement = 'AccountsManagement',
  UserProfile = 'UserProfile',
  ClientsAnalytics = 'ClientsAnalytics',

  TrackingVendors = 'TrackingVendors',
  FeatureFlags = 'FeatureFlags',
  JobsManagement = 'JobsManagement',
  ServicesHealth = 'ServicesHealth',
  IssuesDocumentation = 'IssuesDocumentation',
  KnowledgeCenter = 'KnowledgeCenter',
  KnowledgeCenterArticle = 'KnowledgeCenterArticle',
  KnowledgeCenterSearch = 'KnowledgeCenterSearch',
  FlightAcademy = 'FlightAcademy',
  CreativePage = 'CreativePage',
  WidgetsLibrary = 'WidgetsLibrary',
  WidgetEdit = 'WidgetEdit',
  TemplateDynamicParameters = 'TemplateDynamicParameters',
  CreativeTemplatePreview = 'CreativeTemplatePreview',
  CreativePreview = 'CreativePreview',
  PublicCreativePreview = 'PublicCreativePreview',
  CampaignTearSheetPreview = 'CampaignTearSheetPreview',
  CampaignTearSheetDraftPreview = 'CampaignTearSheetDraftPreview',
  CreativesLibrary = 'CreativesLibrary',
  CreativeDynamicParameters = 'CreativeDynamicParameters',
  CreativeTemplatesLibrary = 'CreativeTemplatesLibrary',
  SmartCreativesLibrary = 'SmartCreativesLibrary',
  SmartCreativeWorkflowBuilder = 'SmartCreativeWorkflowBuilder',
  LocationFeedsLibrary = 'LocationFeedsLibrary',
  LocationFeed = 'LocationFeed',
  ProductFeedsLibrary = 'ProductFeedsLibrary',
  ProductFeed = 'ProductFeed',
  AssetsFileManager = 'AssetsFileManager',
  FontsLibrary = 'FontsLibrary',
  AttributionSignals = 'AttributionSignals',
  BrandGuidelines = 'BrandGuidelines',
  AudiencesLibrary = 'AudiencesLibrary',
  DynamicSourceOptions = 'DynamicSourceOptions',
  MyProfile = 'MyProfile',
  UserSignUp = 'UserSignUp',
  TearsheetExportMain = 'TearsheetExportMain',
  TearsheetExportDisplayVariation = 'TearsheetExportDisplayVariation',
  TearsheetExportVideoVariation = 'TearsheetExportVideoVariation',
  TemplateTearsheetExportVideoVariation = 'TemplateTearsheetExportVideoVariation',
  ErrorCodes = 'ErrorCodes',
  NoPermissions = 'NoPermissions',
  CampaignPage = 'CampaignPage',
  CampaignPagePublic = 'CampaignPagePublic',
  CampaignLogicPublic = 'CampaignLogicPublic',
  ConceptPlanPublic = 'ConceptPlanPublic',
  CampaignAdsPublic = 'CampaignAdsPublic',
  TemplateWorkflow = 'TemplateWorkflow',
  TemplateWorkflowBuilder = 'TemplateWorkflowBuilder',
  TemplateWorkflowMap = 'TemplateWorkflowMap',
  TemplateWorkflowSet = 'TemplateWorkflowSet',
  TemplateWorkflowTearsheetList = 'TemplateWorkflowTearsheetList',
  TemplateWorkflowTearsheet = 'TemplateWorkflowTearsheet',
  TemplateWorkflowTearsheetPreview = 'TemplateWorkflowTearsheetPreview',
  ContentFeedsLibrary = 'ContentFeedsLibrary',
  ContentFeedPage = 'ContentFeedPage',
  ContentFeedItems = 'ContentFeedItems',
  ContentFeedMapping = 'ContentFeedMapping',
  ContentFeedSets = 'ContentFeedSets',
  ContentFeedAiGenerationSetup = 'ContentFeedAiGenerationSetup',
  ContentFeedDraftItems = 'ContentFeedDraftItems',
  TargetPlatforms = 'TargetPlatforms',
}

enum PathParamType {
  String = 'string',
  Number = 'number',
}

enum QueryParamType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  OneOf = 'one of',
  OneOrMoreOf = 'one or more of',
}

export {RouteKey, PathParamType, QueryParamType};
